import { useState } from 'react'

import { api, fehlertext } from '../../api/client'
import type { Trip } from '../../api/types'
import { useQueryClient } from '@tanstack/react-query'
import { keys } from '../../hooks/queries'
import { Blasenwahl, type Blasensatz } from '../settings/Blasenwahl'
import { useTexte } from '../../texte'

/**
 * Die Farbe der Sprechblasen **in dieser Reise, nur für mich** (#52).
 *
 * Aus dem Betrieb: „Auch Mitlesende sollen die Farbe der Chatblasen einstellen
 * können (aber nicht den Hintergrund!). Voreinstellung ist die Einstellung des
 * Autors."
 *
 * **Der Hintergrund gehört dem Bericht, die Blase den Augen.** Deshalb steht
 * hier genau eine Karte und nicht die drei des Autors: ein Mitlesender
 * ändert nichts an dem, was die anderen sehen.
 *
 * **Leer heißt „wie der Autor"** — die dritte Stufe der Kette
 * Voreinstellung → Reise → Leser. Der Knopf an jeder Zeile sagt es.
 */
export function MeineBlasenfarben({ trip }: { trip: Trip }) {
  const texte = useTexte()
  const t = texte.reise.blasen
  const client = useQueryClient()
  const [laeuft, setLaeuft] = useState(false)
  const [gemeldet, setGemeldet] = useState(false)
  const [problem, setProblem] = useState<string | null>(null)

  const meine = trip.chat_bubbles_mine ?? { own: null, other: null }

  return (
    <div className="card card--seite">
      <h2 className="card__titel">{t.titel}</h2>
      <Blasenwahl
        lead={t.leadEigen}
        werte={{
          chat_own_color: meine.own ?? '',
          chat_other_color: meine.other ?? '',
        }}
        /* **Was das Farbfeld zeigt, solange hier nichts steht**: die Farbe des
           Autors. Aus dem Betrieb gemeldet -- dort stand die allgemeine
           Voreinstellung, und die gilt in dieser Reise gar nicht. */
        ererbt={{
          chat_own_color: trip.chat_bubbles?.own ?? '',
          chat_other_color: trip.chat_bubbles?.other ?? '',
        }}
        leerText={t.wieDerAutor}
        laeuft={laeuft}
        fehler={problem}
        gemeldet={gemeldet}
        onSpeichern={async (satz: Blasensatz) => {
          setGemeldet(false)
          setProblem(null)
          setLaeuft(true)
          try {
            const neu = await api.post<Trip>(`/api/trips/${trip.id}/ansicht`, satz)
            client.setQueryData(keys.trip(trip.id), neu)
            setGemeldet(true)
          } catch (fehler) {
            setProblem(
              fehlertext(fehler),
            )
            throw fehler
          } finally {
            setLaeuft(false)
          }
        }}
      />
    </div>
  )
}
